import { render, staticRenderFns } from "./HomeProfileGenie.vue?vue&type=template&id=f4a712c8&scoped=true&"
import script from "./HomeProfileGenie.vue?vue&type=script&lang=js&"
export * from "./HomeProfileGenie.vue?vue&type=script&lang=js&"
import style0 from "./HomeProfileGenie.vue?vue&type=style&index=0&id=f4a712c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a712c8",
  null
  
)

export default component.exports